/**
 * Clone a telemetry event; generally so we don't modify the input telemetry event
 * Also sets dataFields to [] if it isn't already set
 * @param event - The event to clone
 */
export function cloneEvent(event) {
    var localEvent = { eventName: event.eventName, eventFlags: event.eventFlags };
    if (!!event.telemetryProperties) {
        localEvent.telemetryProperties = {
            ariaTenantToken: event.telemetryProperties.ariaTenantToken,
            nexusTenantToken: event.telemetryProperties.nexusTenantToken
        };
    }
    if (!!event.eventContract) {
        localEvent.eventContract = { name: event.eventContract.name, dataFields: event.eventContract.dataFields.slice() };
    }
    localEvent.dataFields = !!event.dataFields ? event.dataFields.slice() : [];
    return localEvent;
}
//# sourceMappingURL=TelemetryEvent.js.map